import React, {Component} from 'react';
import PropTypes from "prop-types";
import {translate} from 'react-i18next';


class RemoveView extends Component {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.applyDelete = this.applyDelete.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.state = {
      apply: false,
    };
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      apply: true
    });
    this.props.removeAction(this.props.profile);
  }

  applyDelete() {
    this.setState({
      apply: true
    });
  }

  cancelDelete() {
    this.setState({
      apply: false
    });
  }

  render() {
    const {apply} = this.state;
    const {t, inProgress} = this.props;
    return (
      <div className="profile__delete">
        <form onSubmit={this.handleSubmit}>
          <p>
            {t('confirm_delete_user')}
          </p>
          {!apply &&
          <div className="form__row">
            <button className="form__button" type="button" onClick={this.applyDelete}>{t('understand')}</button>
          </div>
          }
          {apply &&
          <div className="form__row">
            <div className='profile__double-buttons profile__double-buttons--centered'>
              <button type="button" className="form__button" onClick={this.cancelDelete}>{t('cancel')}</button>
              <button disabled={inProgress} className="form__button" type="submit">{t('delete_user')}</button>
            </div>
          </div>
          }
        </form>
      </div>
    );
  }
}

RemoveView.propTypes = {
  profile: PropTypes.object.isRequired,
  removeAction: PropTypes.func,
  inProgress: PropTypes.bool
};

export default translate('translations')(RemoveView);



// WEBPACK FOOTER //
// ./src/components/Customer/Profile/RemoveView.js